import {isFeatureEnabled} from 'feature-flags';

import {yupNumber} from 'shared/web';

import i18n from '../../../i18n/i18n';
import {featureFlags} from '../../../utils/featureFlags';
import {MIN_FIRST_REGISTRATION_YEAR} from '../constants/minFirstRegistrationYear';

const MESSAGE_KEY = 'page.create.validation.firstRegistrationOnYearMustBeOneOfOptions';

export function buildFirstRegistrationOnYearValidation(allowedYearValues: number[]) {
  const base = yupNumber
    .min(MIN_FIRST_REGISTRATION_YEAR, ({min, value}) =>
      i18n.t('page.create.validation.firstRegistrationOnYearMustBeAtLeast', {
        minYear: min,
        actualYear: value,
      })
    )
    .required();

  if (!isFeatureEnabled(featureFlags.PR_FORM_STATISTICS)) {
    return base;
  }

  return base.oneOf(allowedYearValues, (params: {value: number}) =>
    i18n.t(MESSAGE_KEY, {
      value: params.value,
    })
  );
}
